// Class: lime.graphics.cairo._CairoSurface.CairoSurface_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Constructor

var CairoSurface_Impl_ = function(){}

// Meta

CairoSurface_Impl_.__name__ = "lime.graphics.cairo._CairoSurface.CairoSurface_Impl_";
CairoSurface_Impl_.__isInterface__ = false;
CairoSurface_Impl_.prototype = {
	
};
CairoSurface_Impl_.prototype.__class__ = CairoSurface_Impl_.prototype.constructor = $hxClasses["lime.graphics.cairo._CairoSurface.CairoSurface_Impl_"] = CairoSurface_Impl_;

// Init



// Statics

CairoSurface_Impl_.flush = function(this1) {
}


// Export

exports.default = CairoSurface_Impl_;